module.exports = __webpack_public_path__ + "img/ico_close.0e61afa3.svg";